if (!customElements.get("payment-weekday-selector")) {
    class PaymentWeekdaySelector extends HTMLElement {
        constructor() {
            super();
            this.radios = this.querySelectorAll('input[type="radio"][name="weekday"]');
            this.frequencyRadios = document.querySelectorAll('input[name="everyWeek"]');
            this.nextOrderText = document.querySelector("#next-order-text");
            this.nextOrderDate = document.querySelector("#next-order-date");
            this.rescheduledText = document.querySelector("#next-order-rescheduled");
            this.holidayText = document.querySelector("#next-order-holiday");

            // Initialize blockedDates from the data attribute once during construction
            this.blockedDates = this.parseBlockedDates();
        }

        get currentWeekday() {
            return this.getAttribute("data-payment-weekday");
        }

        parseBlockedDates() {
            if(!this.dataset.blockedDates) return null;

            try {
                return JSON.parse(this.dataset.blockedDates)
            } catch {
                // If the JSON is malformed, log an error and return null to avoid breaking the component
                console.error("Invalid JSON in data-blocked-dates attribute");
                return null;
            }
        }

        connectedCallback() {
            this.initializeComponent();

            this.radios.forEach(radio => {
                radio.addEventListener("change", 
                    this.handleWeekdayChange.bind(this)
                );
            });

            this.frequencyRadios.forEach(radio => {
                radio.addEventListener("change", () => {
                    // Use the value of the "data-payment-weekday" attribute if it exists, otherwise resolve based on current day
                    const selectedValue = this.resolveWeekdayValue()
                    const nextChargeDate = this.calculateNextChargeDate(selectedValue);
                    this.renderNextChargeDate(nextChargeDate);
                });
            });
        }

        initializeComponent() {
            // Use the value of the "data-payment-weekday" attribute if it exists, otherwise resolve based on current day
            const finalValue = this.resolveWeekdayValue();
            const nextChargeDate = this.calculateNextChargeDate(finalValue);

            this.setCheckedRadio(finalValue); // Update the select UI
            this.setCartAttributes(nextChargeDate.date, finalValue); // Update cart attribute
            this.renderNextChargeDate(nextChargeDate); // Update next order date display
        }

        handleWeekdayChange(event) {
            if (!event.target.checked) return;

            // Use the value of the selected radio button to update the cart attribute and next order date
            const selectedValue = event.target.value;
            const nextChargeDate = this.calculateNextChargeDate(selectedValue);

            this.setCartAttributes(nextChargeDate.date, selectedValue);
            this.renderNextChargeDate(nextChargeDate);
        }

        renderNextChargeDate(nextChargeDate) {
            if (!nextChargeDate) return;

            const { date, rescheduled } = nextChargeDate;
            if (date && this.nextOrderDate && this.nextOrderText) {
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                this.nextOrderDate.textContent = date.toLocaleDateString("de-DE", options);

                this.nextOrderText.classList.remove("hidden");
            }

            if(!this.rescheduledText) return;

            if (rescheduled === true) {
                this.rescheduledText.classList.remove("hidden");
            } else {
                this.rescheduledText.classList.add("hidden");
            }
        }

        setCheckedRadio(value) {
            this.radios.forEach(radio => {
                radio.checked = radio.value === value;
            });
        }

        setCartAttributes(nextChargeDate, paymentWeekday) {
            var formData = new FormData();
            formData.append("attributes[payment-weekday]", paymentWeekday);
            // Only include next-charge-date if it's valid and not null
            if (nextChargeDate) {
                formData.append("attributes[next-charge-date]", nextChargeDate.toISOString().slice(0, 10)); // Format as YYYY-MM-DD
            }

            const spinner = document.querySelector(".selling-plan__loading-spinner.js-loader");
            const dialogue = document.querySelector(".selling-plan-dialogue");
            const dialogueClose = document.querySelector(".dialogue-close");
            if (spinner) {
                spinner.classList.remove("hidden");
            }
            if (dialogue) {
                dialogue.classList.add("loading");
            }
            if (dialogueClose) {
                dialogueClose.classList.add("loading");
            }

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    console.log("Payment weekday", data.attributes["payment-weekday"]);
                    console.log("Next charge date", data.attributes["next-charge-date"]);
                })
                .catch(error => console.error("Error updating attributes:", error))
                .finally(() => {
                    if (spinner) {
                        spinner.classList.add("hidden");
                    }
                    if (dialogue) {
                        dialogue.classList.remove("loading");
                    }
                    if (dialogueClose) {
                        dialogueClose.classList.remove("loading");
                    }

                    this.setAttribute("data-payment-weekday", paymentWeekday);
                });
        }

        resolveWeekdayValue() {
            if (this.currentWeekday !== undefined && this.currentWeekday !== null && this.currentWeekday !== '') {
                return this.currentWeekday;
            }

            const today = new Date().getDay(); // 0 = Sunday, ..., 6 = Saturday

            return this.isWeekend(today) ? "0" : String(today - 1); // Adjust so Monday = "0"
        }

        calculateNextChargeDate(selectedValue) {
            const selectedInterval = this.getSelectedInterval();
            if (!selectedInterval) return {
                date: null,
                rescheduled: false
            };

            const intervalDays = parseInt(selectedInterval, 10);
            const preferredWeekday = parseInt(selectedValue, 10); // 0 = Monday

            let nextChargeDate = new Date();
            nextChargeDate.setDate(nextChargeDate.getDate() + intervalDays);

            // Set to the first date with the preferred weekday after the interval
            const dayDiff = (preferredWeekday + 7 - (nextChargeDate.getDay() - 1)) % 7; // -1 to align Monday=0
            nextChargeDate.setDate(nextChargeDate.getDate() + dayDiff);

            let rescheduled = false;

            // Skip blocked dates
            while (this.isDateBlocked(nextChargeDate)) {
                nextChargeDate.setDate(nextChargeDate.getDate() + 1);
                rescheduled = true;
            }

            return {
                date: nextChargeDate,
                rescheduled: rescheduled
            };
        }

        getSelectedInterval() {
            const checkedRadio = document.querySelector('input[name="everyWeek"]:checked');
            switch(checkedRadio?.value) {
                case "0":
                    return 7;
                case "1":
                    return 14;
                case "2":
                    return 28;
                case "3":
                    return 56;
                default:
                    return null;
            }
        }

        isDateBlocked(date) {
            if(!this.blockedDates) return false;

            const day = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
            if (this.isWeekend(day)) {
                return true;
            }

            return this.blockedDates.some(blockedDate => 
                blockedDate.dates_to_block.some(dateToBlock => 
                    dateToBlock === date.toISOString().slice(0, 10)
                )
            );
        }

        isWeekend(day) {
            return day === 5 || day === 6 || day === 0; // Friday, Saturday, Sunday
        }
    }
    customElements.define("payment-weekday-selector", PaymentWeekdaySelector);
}